import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolAction } from '@cbridge-packages/symbol';
import { MultiSelectSidebarAction } from '@cbridge-packages/multi-select-sidebar';

export const closeBulkEditSidebarOnDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolAction.bulkUpdate.done,
    SymbolAction.bulkRemove.done,
  ),
  mergeMap(() => [
    MultiSelectSidebarAction.closeBulkEditSidebar(),
    MultiSelectSidebarAction.clearSelection(),
  ]),
);
